import { render, staticRenderFns } from "./MenuMainContent.vue?vue&type=template&id=354b7564&"
import script from "./MenuMainContent.vue?vue&type=script&lang=js&"
export * from "./MenuMainContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports